module.exports = __webpack_public_path__ + "media/images/common/search_btn-46b56c21c5651c730c2292fbb2ee636a.png";